import React, { useEffect, useState } from "react";
import Popover from "@material-ui/core/Popover";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import s from "./styles.module.css";
import CheckBoxOutlineBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import { InputV2 } from "../../../../components/redesign-components/InputV2/InputV2";

export const TagsSelect = ({
  values,
  name,
  onChange,
  emptyValue,
  showSelectedNumberOnValue,
  optionsLabel,
  allowLocalSearch,
  options,
  onClear,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);

  const [searchValue, setSearchValue] = useState("");
  const [optionsState, setOptionsState] = useState([]);

  useEffect(() => {
    if (searchValue) {
      function fuzzySearch(input, array) {
        const inputLower = input.toLowerCase();

        return array.filter((item) => {
          let itemLower = `${item}`.toLowerCase();
          let searchIndex = 0;

          for (let i = 0; i < itemLower.length; i++) {
            if (itemLower[i] === inputLower[searchIndex]) {
              searchIndex++;
            }
            if (searchIndex === inputLower.length) {
              return true;
            }
          }

          return false;
        });
      }

      setOptionsState(fuzzySearch(searchValue, options));
    } else {
      setOptionsState(options);
    }
  }, [searchValue]);

  useEffect(() => {
    setOptionsState(options);
  }, [options]);

  const handleClick = (event) => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 300);
    setAnchorEl(event.currentTarget);
  };

  const handleOptionClick = (value) => {
    onChange(name, value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className={s.container}>
      <div
        style={{ fontSize: "14px" }}
        className={`${s.selectWrapper} ${
          values.length ? s.selectActive : s.selectInActive
        } ${isAnimating ? s.animateButton : ""}`}
        onClick={handleClick}
      >
        <div className={s.selectValue}>
          <span>
            {values.length ? (
              showSelectedNumberOnValue ? (
                <>
                  <span
                    style={{
                      backgroundColor: "#E2D2FC",
                      padding: "2px 8px 2px 8px",
                      borderRadius: "14px",
                      marginRight: "5px",
                    }}
                  >
                    {values.length}
                  </span>
                  {emptyValue}
                </>
              ) : (
                `${options.find((el) => el === values[0])} ${
                  values.length > 1 ? `+${values.length - 1}` : ""
                }`
              )
            ) : (
              emptyValue
            )}
          </span>
          <KeyboardArrowDownIcon />
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            minWidth: "200px",
            marginTop: "10px",
            borderRadius: "10px",
          },
        }}
      >
        <div className={s.options}>
          <div className={s.optionsLabel}>{optionsLabel}</div>

          {allowLocalSearch ? (
            <div className={s.searchContainer}>
              <InputV2
                onChange={(name, value) => setSearchValue(value)}
                name="search"
                value={searchValue}
                placeholder="Search"
                disabled={false}
              />
            </div>
          ) : (
            <></>
          )}

          {optionsState.map((el) => (
            <div
              style={{ display: "flex", gap: "5px" }}
              className={s.option}
              key={el}
              onClick={() => handleOptionClick(el)}
            >
              {values.length && values.includes(el) ? (
                <CheckBoxOutlinedIcon style={{ color: "#4009A5" }} />
              ) : (
                <CheckBoxOutlineBlankOutlinedIcon
                  style={{ color: "#4009A5" }}
                />
              )}
              <div>{el}</div>
            </div>
          ))}
        </div>
        <div className={s.clearButtonContainer}>
          <span
            className={values.length ? s.clearButton : s.inactiveClearButton}
            onClick={onClear}
          >
            Clear
          </span>
        </div>
      </Popover>
    </div>
  );
};
